import singleSpaReact from "single-spa-react";
import React from "react";
import ReactDOM from "react-dom";
import { IceAuthRouter } from "./components/Auth/IceSso/IceAuth";

const lifecycles = singleSpaReact({
  React,
  ReactDOM,
  rootComponent: () => (
    <React.StrictMode>
      <IceAuthRouter />
    </React.StrictMode>
  ),
  errorBoundary(/*err, info, props*/) {
    return <div>Error</div>;
  },
  renderType: "createRoot",
});

// noinspection JSUnusedGlobalSymbols
export const { bootstrap, mount, unmount } = lifecycles;
